export enum ORDERS_STATE_GROUPS {
  all = "all",
  new = "new",
  payedWithoutLogistic = "payed_without_logistic",
  delivered = "delivered",
  deliveryStore = "delivery_store",
  finished = "finished",
  cancelled = "cancelled",
}

export type OrderFilterCategories = {
  payed?: boolean;
  notPayed?: boolean;
  deliveryHome?: boolean;
  pickup?: boolean;
  packed?: boolean;
  notPacked?: boolean;
  send?: boolean;
  withoutSend?: boolean;
  pickedUp?: boolean;
  withoutPickup?: boolean;
  cancelled?: boolean;
  finished?: boolean;
  pendingReview?: boolean;
};

export type OrderFilter = {
  stateGroup: ORDERS_STATE_GROUPS | string;
  categories: OrderFilterCategories;
  orderBy?: "desc" | "asc";
  datesRage?: Date[];
};
